import classNames from 'classnames'
import Tabs, { TabType } from './Tabs'

type Props = {
  className?: string
  title: string
  /** Drawn right after the title, such as a personal list's lock. */
  titleMarker?: React.ReactNode
  subTitle?: string
  /** A quiet line under the title row, such as a list's kind. */
  subheader?: React.ReactNode
  totalItems?: number | string
  primaryButtonSlot?: React.ReactElement
  secondaryButtonSlot?: React.ReactElement
  otherButtons?: React.ReactElement[]
  tabs?: TabType[]
  learnMore?: React.ReactElement
}

export function PageHeader({
  className,
  title,
  titleMarker,
  subTitle,
  subheader,
  totalItems,
  primaryButtonSlot,
  secondaryButtonSlot,
  otherButtons,
  tabs,
  learnMore,
}: Props): React.ReactElement {
  let getItemsText = () => {
    if (typeof totalItems === `number`) {
      return `${totalItems.toLocaleString(`en-US`)} ${totalItems !== 1 ? `items` : `item`}`
    } else {
      return totalItems
    }
  }
  const heading = <h1 className="gilroy text-heading-xl text-strong">{title}</h1>
  return (
    <>
      <div
        // flex-wrap is mobile-only: ungated it let the action group drop to a
        // second row on desktop, where this row has always been a single line.
        className={classNames(
          className,
          `flex flex-wrap items-center justify-between gap-x-3 gap-y-2 pb-6 md:flex-nowrap md:gap-0 md:pb-8`,
        )}
      >
        <div>
          {/* Wraps rather than squeezes: a long title on a phone used to break the count chip
              into two lines. */}
          <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
            {heading}
            {titleMarker}
            {typeof totalItems !== `undefined` && (
              <div className="border-default flex shrink-0 items-center justify-center whitespace-nowrap rounded border-[0.5px] bg-gray-minimal px-1.5 py-0.5 text-label-xs text-gray-strong">
                <p>{getItemsText()}</p>
              </div>
            )}
            {learnMore}
          </div>
          {subTitle && <p className="mt-2 text-heading-md text-subtle">{subTitle}</p>}
          {subheader}
        </div>
        <div className="flex flex-wrap items-center gap-3 md:flex-nowrap md:gap-4">
          {otherButtons?.map((button, i) => (
            <div key={i}>{button}</div>
          ))}
          {secondaryButtonSlot}
          {primaryButtonSlot}
        </div>
      </div>
      {tabs ? (
        <div className="overflow-x-auto">
          <Tabs tabs={tabs} />
        </div>
      ) : null}
    </>
  )
}
